module.exports = "/img/_/_/_/assets/images/creeper/book/epic//6.jpg?edf15b42777f00cba1697368007e5a6e";